import { isProd } from 'utils/env.utils';

import { SiteLocale } from './i18n.constants';

export const SURVICATE_SURVEYS = {
  POST_EVENT_FEEDBACK: isProd
    ? 'prod_survicate_post_event_feedback'
    : 'survicate_post_event_feedback',
} as const;

export type SurvicateSurveyType =
  (typeof SURVICATE_SURVEYS)[keyof typeof SURVICATE_SURVEYS];

export const getGeneralFeedbackUrl = (locale: SiteLocale) =>
  isProd ? GENERAL_FEEDBACK_URL_PROD[locale] : GENERAL_FEEDBACK_URL_DEV[locale];

export const getEventFeedbackUrl = (locale: SiteLocale) =>
  isProd ? EVENT_FEEDBACK_URL_PROD[locale] : EVENT_FEEDBACK_URL_DEV[locale];

const GENERAL_FEEDBACK_URL_DEV: Record<SiteLocale, string> = {
  [SiteLocale.EN]: 'https://survey.partyprep.nofomo.com/en/feedback',
  [SiteLocale.AR]: 'https://survey.partyprep.nofomo.com/ar/feedback',
};

const GENERAL_FEEDBACK_URL_PROD: Record<SiteLocale, string> = {
  [SiteLocale.EN]: 'https://survey.nofomo.com/en/feedback',
  [SiteLocale.AR]: 'https://survey.nofomo.com/ar/feedback',
};

const EVENT_FEEDBACK_URL_DEV: Record<SiteLocale, string> = {
  [SiteLocale.EN]: 'https://survey.partyprep.nofomo.com/en/eventfeedback',
  [SiteLocale.AR]: 'https://survey.partyprep.nofomo.com/ar/eventfeedback',
};

const EVENT_FEEDBACK_URL_PROD: Record<SiteLocale, string> = {
  [SiteLocale.EN]: 'https://survey.nofomo.com/en/eventfeedback',
  [SiteLocale.AR]: 'https://survey.nofomo.com/ar/eventfeedback',
};
